<button matTooltip="{{'menu.toolbar.history' | translate}}" mat-icon-button (click)="isOpen = !isOpen" cdkOverlayOrigin
  #trigger="cdkOverlayOrigin">
  <mat-icon>history</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="15"
  (backdropClick)="isOpen = false"
  cdkConnectedOverlayBackdropClass="invisibleBackdrop"
  >
  <div class="pm-history-panel mat-elevation-z8">
    <mat-card appearance="outlined">
      <mat-card-header>
        <h4 mat-card-subtitle>{{'history.popup.recent' | translate}}</h4>
      </mat-card-header>
      <mat-card-content class="history-buttons">
        <a class="show-all-link" href="#" (click)="!!showAll();">{{'history.popup.show-all' | translate}}</a>
        <div class="controls">
          <a href="#" (click)="!!expandAll();">{{'action.expand-all' | translate}}</a>&nbsp;
          <a href="#" (click)="!!closeAll()">{{'action.collapse-all' | translate}}</a>
        </div>
      </mat-card-content>
    </mat-card>
    @if (loaded) {
      <mat-accordion [multi]="true" displayMode="flat">
        @for (eventBlock of historyEventBlock; track identity($index, eventBlock)) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{'history.user.update' |translate:eventBlock}}</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <pm-event-block-view [eventBlock]="eventBlock"></pm-event-block-view>
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
    @if (!loaded) {
      <mat-spinner [diameter]="32"></mat-spinner>
    }
    @if (historyEventBlock.length == 0) {
      <mat-card appearance="outlined" class="no-recent-events-card">
        <h4 mat-card-subtitle>{{'history.popup.no-recent' | translate}}</h4>
      </mat-card>
    }
  </div>
</ng-template>
